import { useState } from 'react';
import { Button } from '@/shared/ui/Button';
import { FormField } from '@/shared/ui/FormField';
import { ApiError } from '@/shared/api/client';
import { passwordLogin } from './api';
import type { LoginResponseLike } from '@/shared/auth/storage';

interface Props {
  onLoggedIn: (res: LoginResponseLike) => void;
}

export function PasswordStep({ onLoggedIn }: Props) {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (!/^\d{8}$/.test(phone)) {
      setError('Утасны дугаар буруу (8 оронтой).');
      return;
    }
    if (password.length < 6) {
      setError('Нууц үг хэт богино байна.');
      return;
    }
    setBusy(true);
    try {
      const login = await passwordLogin(phone, password);
      onLoggedIn(login);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Утас эсвэл нууц үг буруу байна.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={onSubmit}>
      <FormField
        label="Утасны дугаар"
        name="pw-phone"
        inputMode="numeric"
        maxLength={8}
        value={phone}
        onChange={(e) => setPhone(e.currentTarget.value.replace(/\D/g, ''))}
        required
      />
      <div style={{ height: 12 }} />
      <FormField
        label="Нууц үг"
        name="pw"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.currentTarget.value)}
        required
        error={error}
      />
      <Button type="submit" disabled={busy} icon="box-arrow-in-right" style={{ marginTop: 14, width: '100%' }}>
        {busy ? 'Нэвтэрч байна…' : 'Нэвтрэх'}
      </Button>
    </form>
  );
}
